/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Node } from './node';


export interface NamedNodeMap { 
    length?: number;
    namedItemNS?: Node;
    namedItem?: Node;
}

